exports.InterceptorService = require('./lib/interceptor-service').InterceptorService;
exports.provideInterceptorService = require('./lib/interceptor-provider').provideInterceptorService;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-interceptors/index.js
// module id = ./node_modules/ng2-interceptors/index.js
// module chunks = vendor